import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import useLanguageChange from "../../hooks/useLanguageChange";
import { ROOM_TYPE } from "../../constants/Constants";
import CenterModal from "../UI/Modal/CenterModal";
import { hanldeRoomParticipantExceed } from "../../actions/onLoadFunctionAction";

const RoomErrorModals = ({ isRoomParticipantExceed, joinMeetingData, dispatchJoinMeeting }) => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();

    const closeRoomParticipantExceedModal = () => {
        dispatch(hanldeRoomParticipantExceed(false));
    };

    const handleRetryButton = () => {
        closeRoomParticipantExceedModal();
        dispatchJoinMeeting();
    };

    const roomParticipantExceedHeader = useMemo(() => {
        return (
            <>
                <h5 className='modal-title'>
                    {joinMeetingData?.sessionConfigurations?.SHOWMEROOMTYPE === ROOM_TYPE.SMALL
                        ? localisedValues?.group_call_limit_reached
                        : localisedValues?.go_room_call_limit_reached}
                </h5>
                <button type='button' className='btn-close' aria-label='Close' onClick={() => closeRoomParticipantExceedModal()}>
                    <span className='btn-icon icon-close-light'></span>
                </button>
            </>
        );
    }, [isRoomParticipantExceed]);

    const roomParticipantExceedBody = useMemo(() => {
        return (
            <div className='cms-modal-text'>
                <p>{localisedValues?.contact_admin_to_increase_participant_limit}</p>
            </div>
        );
    }, [isRoomParticipantExceed]);

    const roomParticipantExceedFooter = useMemo(() => {
        return (
            <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
                <div className='button'>
                    <button className='btn default-btn-link' onClick={() => closeRoomParticipantExceedModal()}>
                        {localisedValues?.cancel_initcap}
                    </button>
                </div>
                <div className='button'>
                    <button className='btn default-btn-primary' onClick={() => handleRetryButton()}>
                        {localisedValues?.retry}
                    </button>
                </div>
            </div>
        );
    }, [isRoomParticipantExceed]);

    return (
        <CenterModal
            showModal={isRoomParticipantExceed}
            closeModal={() => closeRoomParticipantExceedModal()}
            modalClass='default-modal modal-small mob-bottom-top'
            bodyClassName='default-custom-scroll'
            className='modal-dialog-centered'
            header={roomParticipantExceedHeader}
            body={roomParticipantExceedBody}
            footer={roomParticipantExceedFooter}
            backdrop={"static"}
        />
    );
};

RoomErrorModals.propTypes = {
    isRoomParticipantExceed: PropTypes.func,
    dispatchJoinMeeting: PropTypes.func,
    joinMeetingData: PropTypes.any,
};

export default RoomErrorModals;
